export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const scrollToSelector = selector => {
  document.querySelector(selector).scrollIntoView({ behavior: "smooth" })
};

